import React from 'react';

const Payment = () => {
    return (
        <div style={{marginBottom:'400px', paddingTop: '50px'}}>
            <h2 className='text-center'>Payment System Comming Soon!!!</h2>
        </div>
    );
};

export default Payment;